import cn from 'classnames';
import type { ReactNode } from 'react';
import React, { memo } from 'react';

import { Space } from '@sravni/react-design-system/lib/Space';

import {
  HeaderBrandingBanner,
  PageHeaderBrandingContainer,
  PageHeaderLocation,
  PageHeaderSubHeading,
} from '@src/components/PageHeader';
import { useHeadingTexts } from '@src/components/PageHeader/hooks';
import { useDeviceBranding } from '@src/reducers/branding';

import styles from './BrandingHeaders.module.scss';

interface Props {
  afterHeaders?: ReactNode;
  containerClassName?: string;
  subHeadingHidden?: boolean;
  showHeaders?: boolean;
}

export const BrandingHeaders = memo(({ afterHeaders, containerClassName, showHeaders = true }: Props) => {
  const { creditCalculator } = useDeviceBranding() || {};
  const { headingText, subHeadingText } = useHeadingTexts();

  return (
    <HeaderBrandingBanner brandingConfig={creditCalculator} className={containerClassName}>
      <PageHeaderBrandingContainer className={styles.page_header_branding_container}>
        {showHeaders && (
          <Space className={styles.location_container}>
            <PageHeaderLocation
              className={cn(styles.location)}
              brandingConfig={creditCalculator}
              position="center"
              header={headingText}
            />
            <PageHeaderSubHeading>{subHeadingText}</PageHeaderSubHeading>
          </Space>
        )}
        {afterHeaders}
      </PageHeaderBrandingContainer>
    </HeaderBrandingBanner>
  );
});

BrandingHeaders.displayName = 'BrandingHeaders';
